import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';
import * as VatRateService from '../../../services/api/vat_rate';

interface VatRateListOutput {
  status: StateStatus;
  data: VatRateService.IVatRateListOutput | null;
}

export const useGetVatRateTypes = () => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.VAT_RATE_REDUCER].vatRateTypes
  );
  return data;
};

export const useGetVatRateList = (): VatRateListOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.VAT_RATE_REDUCER].vatRateList
  );
  return data;
};
